module.exports = require('./assignInWith');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/extendWith.js
// module id = 1989
// module chunks = 3